import { Stack, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { useUrl } from "../../../hooks/urlEncoding";
import { routerPaths } from "../../../constants/Paths";
import { UsersListColumnFilterable } from "../../../services/Endpoints/users/UsersListEndpoint";
import { FilterOperatorEnum } from "../../../services/Schemas/ListQueryString";

export interface IUserLink {
  user?: {
    id: number | string;
    name?: null | string;
    email?: null | string;
    email_verified_at?: null | string;
    mobile?: string;
    mobile_verified_at?: string;
    created_at?: string;
    updated_at?: string;
  };
  direction?: "column" | "row" | "row-reverse" | "column-reverse";
  link?: string;
  disabled?: boolean;
}

export default function UserLink({
  user,
  direction = "column",
  link,
  disabled,
}: IUserLink) {
  const { queryStringUrl } = useUrl();
  return (
    <Stack
      gap="1px"
      direction={direction}
      component={!disabled ? Link : Stack}
      justifyContent="start"
      alignItems="center"
      sx={{
        textDecoration: "none",
      }}
      to={
        link ??
        queryStringUrl(routerPaths.USERS, {
          filters: {
            [UsersListColumnFilterable.ID]: {
              column: UsersListColumnFilterable.ID,
              operator: FilterOperatorEnum.EQUAL,
              value: user?.id ?? "",
            },
          },
        })
      }
    >
      {!user?.mobile && (
        <Typography
          textAlign="center"
          variant="footerRegular"
          color={(theme) =>
            !disabled ? theme.palette.others.link : theme.palette.dark[40]
          }
        >
          {user?.id ?? "کاربر ناشناخته"}
        </Typography>
      )}
      <Typography
        textAlign="center"
        variant="footerRegular"
        color={(theme) =>
          !disabled ? theme.palette.others.link : theme.palette.dark[40]
        }
      >
        {user?.name}
      </Typography>
      <Typography
        textAlign="center"
        variant="footerRegular"
        dir={"ltr"}
        color={(theme) =>
          !disabled ? theme.palette.others.link : theme.palette.dark[40]
        }
      >
        {user?.mobile}
      </Typography>
    </Stack>
  );
}
